<template>
    <v-card elevation="2" outlined>
        <v-card-title>
            جزئیات تراکنش
            <v-spacer/>
            <v-icon>mdi-information</v-icon>
        </v-card-title>

        <v-divider/>

        <v-list>
            <v-list-item>
                <v-list-item-icon>
                    <v-icon>mdi-code-less-than-or-equal</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title v-text="this.persian(this.price(request.amount))"/>
                    <v-list-item-subtitle>قیمت</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-list-item>
                <v-list-item-icon>
                    <v-icon>mdi-book-variant</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title v-text="request.type==='deposit'?'افزایش موجودی':'کاهش موجودی'"/>
                    <v-list-item-subtitle>نوع تراکنش</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-list-item>
                <v-list-item-icon>
                    <v-icon>mdi-check</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title v-text="request.type===true?
                      'تایید شده'
                    :  ' رد شده'"/>
                    <v-list-item-subtitle>وضعیت تایید</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>


            <v-list-item>
                <v-list-item-icon>
                    <v-icon>mdi-counter</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title v-text="request.uuid"/>
                    <v-list-item-subtitle>شناسه تراکنش</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-cart</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="request.product_id"/>
              <v-list-item-subtitle>شناسه محصول</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>


            <v-list-item>
                <v-list-item-icon>
                    <v-icon>mdi-shield-check</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title v-text="this.datetime(request.created_at)"/>
                    <v-list-item-subtitle>تاریخ </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

<!--            <v-list-item>-->
<!--                <v-list-item-icon>-->
<!--                    <v-icon>mdi-file</v-icon>-->
<!--                </v-list-item-icon>-->
<!--                <v-list-item-content>-->
<!--                    <v-list-item-title v-text="'تصویر شناسنامه'"/>-->
<!--                    <v-list-item-subtitle>-->
<!--                        <td v-text="'نمایش'" class="clickable" @click="getUserFile(request.birthCertificatePicture)">-->
<!--                            <v-chip v-text="'نمایش'"/>-->
<!--                        </td>-->
<!--                    </v-list-item-subtitle>-->
<!--                </v-list-item-content>-->
<!--            </v-list-item>-->

<!--            <v-list-item>-->
<!--                <v-list-item-icon>-->
<!--                    <v-icon>mdi-file</v-icon>-->
<!--                </v-list-item-icon>-->
<!--                <v-list-item-content>-->
<!--                    <v-list-item-title v-text="'تصویر کارت ملی'"/>-->
<!--                    <v-list-item-subtitle>-->
<!--                        <td v-text="'نمایش'" class="clickable" @click="getUserFile(request.user_info.nidimage)">-->
<!--                            <v-chip v-text="'نمایش'"/>-->
<!--                        </td>-->
<!--                    </v-list-item-subtitle>-->
<!--                </v-list-item-content>-->
<!--            </v-list-item>-->

        </v-list>
    </v-card>
</template>

<script>
export default {
    name: "requestDetails",
    data: () => ({
        residenceProvince: null,
        residenceCity: null,
        employmentProvince: null,
        employmentCity: null,

    }),
    props: ['request'],

    methods: {
        getUserFile(url) {
            let a = document.createElement('a');
            a.target = '_blank';
            a.href = this.uploadUrl + url;
            a.click();
        },

    }

}
</script>

<style scoped>

</style>
